export default "__VITE_ASSET__BLjl1vVI__"